import { render, staticRenderFns } from "./AssinaturaLembraZap.vue?vue&type=template&id=d066dbe4"
import script from "./AssinaturaLembraZap.vue?vue&type=script&lang=js"
export * from "./AssinaturaLembraZap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports